<template>
  <div class="contact-card">
    <div class="person">
      <div class="left">
        <el-image :src="info.avatar_url" />
        <!-- <p :class="['fz-12', info.is_add_wx === '1' ?  'success' : 'warning', 'des' ] ">{{ info.is_add_wx === '1' ? '已加微信' : '未加微信' }}</p> -->
      </div>
      <div class="right">
        <div class="name">{{ contactName}}</div>
        <div class="yx-color-text-secondary">微信号: {{ info.wechat_account ? info.wechat_account : '暂无' }}</div>
        <div class="yx-color-text-secondary">手机号: {{ info.mobile ? info.mobile : '暂无' }}</div>
        <!-- <div class="time yx-color-text-secondary">{{ addTime }}</div> -->
      </div>
    </div>
    <!-- <div class="address">
      <div>收货人：{{ info.delivery_name }}</div>
      <div class="mt-16">手机号：{{ info.delivery_mobile }}</div>
      <div class="mt-16 ellipsis" :title="info.delivery_address">收货地址：{{ info.delivery_address }}</div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'contactCard',
  props: {
    info: {
      type: Object,
      default: _ => ({})
    }
  },
  computed: {
    contactName() {
      const { contact_name, nick_name } = this.info
      return `${contact_name || ''}${contact_name && nick_name ? '-' : ''}${nick_name || ''}`
    },
  },
  methods: {
    
  }
}
</script>

<style lang="less" scoped>
.contact-card {
  display: flex;
  justify-content: space-between;
  .person{
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .el-image {
      width: 52px;
      height: 52px;
      border-radius: 50%;
    }
    .left {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .left p{
      margin-top: 10px;
      padding: 2px 8px;
      border-radius: 10px;
    }
    .success{
      background: rgba(15, 184, 32, .06);
      color: #0FB820;
    }
    .warning{
      background: rgba(250, 143, 20, .08);
      color: #FA8F14;
    }
    .right {
      margin-left: 12px;
      font-size: 14px;
      line-height: 1.5;
      color: #333;
      .time {
        white-space: nowrap;
      }
    }
  }
  .address {
    width: 100%;
    border-radius: 2px;
    background-color: #F8F8F8;
    border: 1px solid #E3E3E3;
    padding: 16px;
    box-sizing: border-box;
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
.des{
  white-space: nowrap;
}
</style>
